import {onDOMReady} from './dom';

const STORAGE_KEY = 'kvik_productFilterSearchQuery';

const initProductFilterSearch = () => {
    const productFilterModal = document.getElementsByClassName('productFilter__modal')[0];
    if (!productFilterModal) {
        return;
    }

    const input = productFilterModal.getElementsByClassName('productFilter__search__input')[0];
    if (!input) {
        return;
    }

    const noResultsMessage = productFilterModal.getElementsByClassName('productFilter__search__noMessage')[0];
    const originalNoResultsText = noResultsMessage ? noResultsMessage.textContent : '';

    const sections = productFilterModal.getElementsByClassName('productFilter__filter');
    const sectionItemsMap = new Map();

    for (let i = 0; i < sections.length; i++) {
        sectionItemsMap.set(sections[i], sections[i].getElementsByClassName('productFilter__filterField'));
    }

    let rafId = null;
    const filter = () => {
        const query = input.value.trim().toLowerCase();

        for (const [section, items] of sectionItemsMap.entries()) {
            let visibleCount = 0;

            for (let j = 0; j < items.length; j++) {
                const item = items[j];
                const name = item.dataset.value?.toLowerCase() || '';
                const matches = name.includes(query);

                if (matches && item.style.display === 'none') {
                    item.style.display = '';
                } else if (!matches && item.style.display !== 'none') {
                    item.style.display = 'none';
                }

                if (matches) {
                    visibleCount++;
                }
            }

            const shouldShowSection = visibleCount > 0;
            if (shouldShowSection && section.style.display === 'none') {
                section.style.display = '';
            } else if (!shouldShowSection && section.style.display !== 'none') {
                section.style.display = 'none';
            }
        }

        let visibleSections = 0;
        for (const section of sectionItemsMap.keys()) {
            if (section.style.display !== 'none') {
                visibleSections++;
            }
        }

        if (noResultsMessage) {
            noResultsMessage.style.display = visibleSections === 0 ? 'block' : 'none';
            if (visibleSections === 0) {
                noResultsMessage.textContent = originalNoResultsText.replace(/%search%/g, input.value.trim());
            }
        }
    };

    const savedQuery = localStorage.getItem(STORAGE_KEY);
    if (savedQuery) {
        input.value = savedQuery;
        filter();
    }

    const scheduleFilter = () => {
        if (rafId !== null) {
            cancelAnimationFrame(rafId);
        }
        rafId = requestAnimationFrame(filter);
        localStorage.setItem(STORAGE_KEY, input.value.trim());
    };

    input.addEventListener('input', scheduleFilter);
};

onDOMReady(() => {
    document.addEventListener('kvik_event_modal_show_modal', () => {
        initProductFilterSearch();
    });
    document.addEventListener('kvik_event_modal_closed_by_user', () => {
        localStorage.removeItem(STORAGE_KEY);
    });
    document.addEventListener('click', (e) => {
        if (
            e.target.closest('.productFilter__buttons__btnSubmit') ||
            e.target.closest('.productFilter__buttons__btnReset')
        ) {
            localStorage.removeItem(STORAGE_KEY);
        }
    });
});